import { createContext, useContext } from 'react'

/**
 * Bring a manual section into view and leave the URL pointing at it, so the
 * position is shareable and survives a reload. `replaceState` keeps the guide
 * as a single history entry and, unlike assigning `location.hash`, does not
 * re-enter the hash listener.
 */
export function scrollToSection(id: string) {
  const target = document.getElementById(id)
  if (!target) return
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  history.replaceState(null, '', `#${id}`)
}

/**
 * How a link inside the manual reaches a section. The guide page overrides the
 * plain scroll, because reaching a section that the active search filtered out
 * means clearing the search first.
 */
const SectionNavigationContext = createContext(scrollToSection)

export const SectionNavigationProvider = SectionNavigationContext.Provider

export function useSectionNavigation() {
  return useContext(SectionNavigationContext)
}
